export default "__VITE_ASSET__Cgy63aa9__"